import { Alert, Grid } from '@mui/material';
import { Event, ResolvedEvent } from '@thro-types/events';

import { FormikContextType, useFormikContext } from 'formik';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { translations } from 'locales/i18n';
import { validateForm } from 'utils/FormErrorHelper';

import { EventCard } from '../../EventCard';
import '../styles/EventModal.scss';
import { eventValidationSchema } from '../validation';

interface Props {
  previousEvent?: Event;
}
export default function EventPreview(props: Props) {
  const { values }: FormikContextType<ResolvedEvent> = useFormikContext();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  useEffect(() => {
    validateForm(values, eventValidationSchema(t), dispatch);
  });

  const hasMaxParticipantsBeenIncreased = (previousEvent: Event, currentEvent: Event) => {
    // Determine which groups have increased their maxParticipants
    const increasedGroups = currentEvent.groups?.filter(newGroup => {
      const existingGroup = previousEvent.groups?.find(group => group.id === newGroup.id);
      return existingGroup && newGroup.maxParticipants > existingGroup.maxParticipants;
    });

    return !!increasedGroups?.length;
  };

  return (
    <Grid container justifyContent="center">
      <Grid item xs={8}>
        {props.previousEvent && hasMaxParticipantsBeenIncreased(props.previousEvent, values) && (
          <Alert severity="info" sx={{ whiteSpace: 'pre-line' }}>
            {t(translations.pages.events.create.maxParticipantIncreasePromotionInfo())}
          </Alert>
        )}
        <EventCard event={{ ...values }} isPreview={true} />
      </Grid>
    </Grid>
  );
}
